var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.59,24c0,.38,.11,.74,.3,1.04,.09,.19,.21,.37,.37,.53l10.24,10.24c.78,.78,2.05,.78,2.83,0s.78-2.05,0-2.83l-6.98-6.98h18.07c1.11,0,2-.89,2-2s-.89-2-2-2H17.34l6.98-6.98c.78-.78,.78-2.05,0-2.83-.39-.39-.9-.59-1.41-.59s-1.02,.2-1.41,.59l-10.24,10.24c-.18,.18-.31,.38-.4,.6-.16,.29-.26,.62-.26,.97Z",
    fill: outlineColor
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowLeft);
export default __webpack_public_path__ + "static/media/ico-arrow-left.b0ec9d7ec91493b52dd85bc055cbf67d.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;